import { classNames } from "@circle-react/helpers/twMergeWithCN";
import type { ComponentPropsWithoutRef, ReactNode } from "react";

const VERTICAL_SPACING = {
  high: "high",
  normal: "normal",
  tight: "tight",
  tightest: "tightest",
};
// From TailwindUI: https://tailwindui.com/components/application-ui/forms/radio-groups

interface FieldsetProps {
  children: ReactNode;
  divProps?: ComponentPropsWithoutRef<"div">;
  legend?: string;
  legendProps?: ComponentPropsWithoutRef<"legend">;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  verticalSpacing?: (typeof VERTICAL_SPACING)[keyof typeof VERTICAL_SPACING];
}

export const Fieldset = ({
  onChange,
  legend = "",
  children,
  legendProps = {},
  divProps = {},
  verticalSpacing = VERTICAL_SPACING.normal,
  ...rest
}: FieldsetProps) => (
  <fieldset {...rest}>
    {legend && (
      <legend className="sr-only" {...legendProps}>
        {legend}
      </legend>
    )}
    <div
      onChange={onChange}
      className={classNames({
        "space-y-6": verticalSpacing == VERTICAL_SPACING.high,
        "space-y-5": verticalSpacing == VERTICAL_SPACING.normal,
        "space-y-3": verticalSpacing == VERTICAL_SPACING.tight,
        "space-y-2": verticalSpacing == VERTICAL_SPACING.tightest,
      })}
      {...divProps}
    >
      {children}
    </div>
  </fieldset>
);
